import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  const scrollToArticles = () => {
    const element = document.getElementById('latest-articles');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          alt="88健康知识 营养素介绍"
          title="88健康知识 营养素介绍"
          className="w-full h-full object-cover object-top"
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20botanical%20illustration%20with%20soft%20green%20leaves%20and%20warm%20amber%20tones%20minimalist%20nature%20inspired%20design%20gentle%20gradients%20organic%20shapes%20health%20wellness%20concept%20clean%20modern%20aesthetic%20subtle%20texture%20soft%20natural%20lighting&width=1600&height=900&seq=hero-main-001&orientation=landscape"
        />
      </div>
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 md:px-8 text-center w-full">
        <div className="max-w-3xl">
          <p className="text-white/70 text-xs md:text-sm tracking-widest mb-3 font-label uppercase">
            {t('siteName')}
          </p>
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
            {t('heroTitle')}
          </h1>
          <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto leading-relaxed mb-6">
            {t('heroSubtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              onClick={scrollToArticles}
              className="bg-primary-500 hover:bg-primary-600 text-white px-6 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer inline-flex items-center gap-1.5"
            >
              {t('heroCta')}
              <i className="ri-arrow-down-line text-xs" />
            </button>
          </div>
        </div>
      </div>

      {/* Scroll down indicator */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/40 text-xl" />
      </div>
    </section>
  );
}